import { useEffect, useState } from "react";
import type { RestoreArchiveMode } from "@supermanus/document-model";
import { VAULT_RETENTION_DAYS } from "@supermanus/document-model";

export function RestoreArchiveDialog({
  sceneLabel,
  onCancel,
  onConfirm,
  title = "Gendan fra arkiv",
  lead,
  confirmLabel = "Gendan",
  legend = "Hvordan vil du gendanne?",
  replaceHint,
  keepHint,
}: {
  sceneLabel: string;
  onCancel: () => void;
  onConfirm: (mode: RestoreArchiveMode) => void;
  title?: string;
  lead?: string;
  confirmLabel?: string;
  legend?: string;
  replaceHint?: string;
  keepHint?: string;
}) {
  const [mode, setMode] = useState<RestoreArchiveMode>("replace");

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === "Escape") onCancel();
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onCancel]);

  return (
    <div className="sm-dialog-backdrop" role="presentation" onClick={onCancel}>
      <div
        className="sm-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="sm-restore-archive-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="sm-restore-archive-title">{title}</h2>
        <p>
          {lead ??
            `Du er ved at gendanne ${sceneLabel}. Vælg, hvad der skal ske med den nuværende scene i manus.`}
        </p>
        <fieldset className="sm-dialog-fieldset">
          <legend>{legend}</legend>
          <label className="sm-setting">
            <input
              type="radio"
              name="restore-archive-mode"
              checked={mode === "replace"}
              onChange={() => setMode("replace")}
            />
            <span>
              Erstat den nuværende scene
              <span className="sm-dialog-hint-inline">
                {" "}
                —{" "}
                {replaceHint ??
                  `den nuværende version lægges i papirkurven (slettes automatisk efter ${VAULT_RETENTION_DAYS} dage)`}
              </span>
            </span>
          </label>
          <label className="sm-setting">
            <input
              type="radio"
              name="restore-archive-mode"
              checked={mode === "keep"}
              onChange={() => setMode("keep")}
            />
            <span>
              Bevar den nuværende scene
              <span className="sm-dialog-hint-inline">
                {" "}
                —{" "}
                {keepHint ??
                  "den arkiverede version indsættes som en ekstra scene"}
              </span>
            </span>
          </label>
        </fieldset>
        <div className="sm-dialog-actions">
          <button type="button" onClick={onCancel}>
            Annuller
          </button>
          <button
            type="button"
            className="sm-dialog-primary"
            onClick={() => onConfirm(mode)}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
